module.exports = __webpack_public_path__ + "static/media/Container.8cc5d22c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/reusable/images/Container.svg
// module id = 958
// module chunks = 0